"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allCountryRegionsAsObject = exports.allCountryRegions = exports.caribbeanIslandRegion = exports.southAmericaRegion = exports.oceaniaRegion = exports.northAmericaRegion = exports.europeRegion = exports.asiaRegion = exports.africaRegion = exports.CountryRegionAbv = void 0;
var CountryRegionAbv;
(function (CountryRegionAbv) {
  CountryRegionAbv["africa"] = "AF";
  CountryRegionAbv["asia"] = "AS";
  CountryRegionAbv["europe"] = "EU";
  CountryRegionAbv["northAmerica"] = "NA";
  CountryRegionAbv["oceaniaRegion"] = "OC";
  CountryRegionAbv["southAmericaRegion"] = "SA";
  CountryRegionAbv["caribbeanIslandRegion"] = "CB";
})(CountryRegionAbv = exports.CountryRegionAbv || (exports.CountryRegionAbv = {}));
exports.africaRegion = {
  abv: CountryRegionAbv.africa,
  name: {
    en: 'Africa',
    ru: 'Африка'
  }
};
exports.asiaRegion = {
  abv: CountryRegionAbv.asia,
  name: {
    en: 'Asia',
    ru: 'Азия'
  }
};
exports.europeRegion = {
  abv: CountryRegionAbv.europe,
  name: {
    en: 'Europe',
    ru: 'Европа'
  }
};
exports.northAmericaRegion = {
  abv: CountryRegionAbv.northAmerica,
  name: {
    en: 'North America',
    ru: 'Северная Америка'
  }
};
exports.oceaniaRegion = {
  abv: CountryRegionAbv.oceaniaRegion,
  name: {
    en: 'Oceania',
    ru: 'Океания'
  }
};
exports.southAmericaRegion = {
  abv: CountryRegionAbv.southAmericaRegion,
  name: {
    en: 'South America',
    ru: 'Южная Америка'
  }
};
exports.caribbeanIslandRegion = {
  abv: CountryRegionAbv.caribbeanIslandRegion,
  name: {
    en: 'Caribbean island',
    ru: 'Карибские острова'
  }
};
exports.allCountryRegions = [exports.africaRegion, exports.asiaRegion, exports.europeRegion, exports.northAmericaRegion, exports.oceaniaRegion, exports.southAmericaRegion, exports.caribbeanIslandRegion];
exports.allCountryRegionsAsObject = {
  [exports.africaRegion.abv]: exports.africaRegion,
  [exports.asiaRegion.abv]: exports.asiaRegion,
  [exports.europeRegion.abv]: exports.europeRegion,
  [exports.northAmericaRegion.abv]: exports.northAmericaRegion,
  [exports.oceaniaRegion.abv]: exports.oceaniaRegion,
  [exports.southAmericaRegion.abv]: exports.southAmericaRegion,
  [exports.caribbeanIslandRegion.abv]: exports.caribbeanIslandRegion
};